<template>
    <touchpoint-overview-row>
        <template slot="left">
            <div class="row">
                <div class="col-2">
                    <i :class="sourceBrickIcon" />
                </div>
                <div class="col-10">
                    <span class="title">{{sourceBrickName}}</span>
                    <br />
                    <span v-for="({operator, description}, index) in displaySourceConditions"
                          class="description"
                          :key="`${operator}-${index}`"
                    >{{operator}} {{audienceDisplayName}} {{description}}</span>
                </div>
            </div>
        </template>

        <template slot="center">
            <touchpoint-overview-icon-magic/>
            
            <br />
            
            <span class="description">{{connectionName}}</span>
        </template>

        <template slot="right">
            <div class="row">
                <div class="col-10">
                    <span class="title">{{destinationBrickName}}</span>

                    <br />

                    <span class="description">{{audienceDisplayName}} {{displayDestinationConditionName}}</span>
                </div>
                <div class="col-2">
                    <i :class="destinationBrickIcon" />
                </div>
            </div>
        </template>
    </touchpoint-overview-row>
</template>

<script>
    import {getBrickIconClass as getBrickIcon} from "@modules/JourneyBuilder/Bricks/brick-icons";
    import brickTypes from '@modules/JourneyBuilder/Bricks/brick-types';
    import {brickDefinitions} from "@modules/JourneyBuilder/Bricks/brick-definitions";
    import {conditionOperatorTypesByValue} from "@modules/JourneyBuilder/ConnectionSettings/condition-operator-types";
    
    import {mapState} from 'vuex';

    import TouchpointOverviewRow from "./TouchpointOverviewRow.vue";
    import TouchpointOverviewIconMagic from "./TouchpointOverviewIconMagic.vue";
    
    export default {
        name: 'touchpoint-info-item',
        components: {
            TouchpointOverviewRow,
            TouchpointOverviewIconMagic
        },
        created() {
            this.audienceDisplayName = brickDefinitions[brickTypes.audience].displayName;
        },
        methods: {
            getOperatorName(conditionType){
                //When no operator is defined; render an empty string
                if(!conditionType){
                    return '';
                }
                
                return conditionOperatorTypesByValue[conditionType].text;
            }
        },
        computed: {
            ...mapState('journeyBuilder/composer', ['availableConnectionConditions']),
            
            conditionNameMap(){
                return this.availableConnectionConditions.reduce((map, condition) => {
                    map[condition.id] = condition.name;
                    return map;
                }, {});
            },
            
            sourceBrickIcon(){
                return getBrickIcon(
                    this.sourceBrickType, 
                    this.sourceBrickConfig
                );
            },
            destinationBrickIcon(){
                return getBrickIcon(
                    this.destinationBrickType,
                    this.destinationBrickConfig
                );
            },
            displaySourceConditions(){
                return this.sourceConditions.map((sourceCondition) => ({
                    description: this.conditionNameMap[sourceCondition.conditionId],
                    operator: this.getOperatorName(sourceCondition.operator),
                    type: sourceCondition.type
                }));
            },
            displayDestinationConditionName(){
                return (this.destinationCondition && this.conditionNameMap[this.destinationCondition.id]) || '';
            }
        },
        data: () => ({
            audienceDisplayName: ''
        }),
        props: {
            connectionName: '',
            
            sourceBrickName: '',
            sourceBrickType: 0,
            sourceBrickConfig: {},
            destinationBrickName: '',
            destinationBrickType: 0,
            destinationBrickConfig: {},
            
            sourceConditions: {
                type: Array,
                default: () => []
            },
            
            destinationCondition: undefined
        }
    }
</script>

<style scoped lang="scss">
    @import "~@modules/JourneyBuilder/Style/touchpoint-info-connection-list-item-row.scss";
</style>